module.exports = __webpack_public_path__ + "static/pseudostates-79235fd455061035dd67f308fa4851dd.png";